import React from 'react'
import ReactHtmlParser from 'react-html-parser';
import { getObject, priceStandardView } from '../../utils/useful';
import moment from 'jalali-moment';
// import TextEditorInput from '../inputs/TextEditorInput';
import Notebooksheet from '../../windows/Notebooksheet';

class TextWidget extends React.Component {
    state = {
        data: ''
    }


    componentDidMount() {
        this.init()
    }

    componentDidUpdate(prevProps) {

        // console.log(this.props.data?.content)
        if (this.props.data?.content != this.state.rawData || this.props.params != prevProps.params) {
            this.init()
        }
    }


    init() {

        this.setState({ rawData: this.props.data?.content })
        // console.log("this.init")
        // console.log(this.props.fullData)
        // console.log(this.props.headers)

        // console.log(this.props.data?.content)
        // console.log('this.props.data?.contentl',this.props.data?.content)
        let data = this.props.data?.content ?? '<span>Enter text ...</span>'
        // console.log(data)
        if (data) {

            // console.log('data Bef', data)

            data = this.textVariableReplacer(this.props.fullData, data, this.props.headers, 'View Record')
            // console.log('this.props.paramscs', this.props.params)
            // console.log('data After', data)

            // console.log(data)

            if (Array.isArray(this.props.params)) {
                for (let i = 0; i < this.props.params.length; i++) {
                    const param = this.props.params[i];
                    // console.log('param',data, param)
                    data = this.textVariableReplacer(param?.info, data, param?.fields, param?.label)
                    // console.log(data)
                }
            }


            // console.log('data', data)

            if (data) {
                data = ReactHtmlParser(data)
            }


            this.setState({ data :null},()=>{
                this.setState({ data })

            })
        } else {

            data = ReactHtmlParser('<span>Enter text ...</span>')

            this.setState({ data: data })
        }
    }

    // changeInputValue(target) {
    //     let value = (target.validity.valid) ? target.value : null
    //     if (value !== null) {
    //         this.props.changeValue(this.props.header.key, value)
    //     }
    // }



    changeValue = (value) => {
        // console.log("changeValue")
        // console.log(value)
        this.props.changeValue(this.props.header.key, value, this.props.extra)
    }


    textVariableReplacer = (data, content, fields, preLabel) => {

        // console.log('contentss', content)
        if (content && typeof content == 'string') {

            let output = content

            let reg = new RegExp('\{\{(.*?)\}\}', 'g')

            let matches = content.match(reg)
            if (matches) {

                // console.log('matches', matches)
                for (let index = 0; index < matches.length; index++) {
                    const match = matches[index];


                    let key = match.replace(/{/g, '').replace(/}/g, '')


                    // console.log('keyis', key)
                    // console.log('fields', fields)
                    if (fields) {
                        for (let j = 0; j < fields.length; j++) {
                            const header = fields[j];

                            let label = header.information?.label
                            if (typeof label == 'string' && label.includes('{{lang}}')) {
                                label = header.information?.label.replace('{{lang}}', '')
                            }

                            if (preLabel) {
                                label = preLabel + ' - ' + label
                            }

                            // console.log('preLabel', preLabel)

                            let headerLabel = header.information?.label
                            if (typeof headerLabel == 'string' && headerLabel.includes('{{lang}}')) {
                                headerLabel = header.information?.label.replace('{{lang}}', '')
                            }
                            // headerLabel
                            if (key == headerLabel || key == label || key == header.key) {

                                let value = getObject(data, header.key)
                                if (value == null) {
                                    value = getObject(data, 'values.' + header.key)
                                }

                                // console.log(value)

                                if (value != null) {

                                    switch (header.type) {
                                        case "PriceInput":
                                            value = priceStandardView(value)
                                            break;

                                        case "NumberInput":
                                            value = priceStandardView(value)
                                            break;

                                        case "DateInput":
                                            let format = 'DD MMM YYYY'
                                            if (header.information?.showHour) {
                                                format = format + ' hh:mm'
                                            }
                                            if (moment(Number(this.props.data)).isValid()) {

                                            }
                                            value = moment(Number(value)).format(format)
                                            break;

                                        case "DateTimeInput":
                                            let mformat = 'DD MMM YYYY'
                                            if (header.information?.showHour) {
                                                mformat = mformat + ' hh:mm'
                                            }
                                            if (moment(Number(this.props.data)).isValid()) {

                                            }
                                            value = moment(Number(value)).format(mformat)
                                            break;


                                        default:
                                            break;
                                    }


                                    let nreg = new RegExp(match, 'g')
                                    output = output.replace(nreg, value)
                                } else {
                                    output = null
                                }

                            }


                        }
                    }
                }
            }

            return output

        }

    }


    render() {

        let styleInfo = this.props.header?.information?.style

        // console.log(this.state.data)
        if (this.state.data || this.props.editMode) {
            return (
                <div className="w-100 h-100 " >

                    {!this.props.editMode && (
                        <div className='' style={{ border: "none", outline: "none", position: "relative", zIndex: 0, padding: styleInfo?.padding }} >

                            {this.state.data}

                        </div>
                    )}
                    {this.props.editMode && (
                        <Notebooksheet ref={el => this.noteEditor = el} header={this.props.header} data={this.props.data?.content} id={this.props.editorId ?? this.state.editorId} changeValue={this.changeValue} updateTextEffectsStyleStatus={this.props.updateTextEffectsStyleStatus} />
                    )}
                </div>
            )
        } else {
            return (
                <></>
            )
        }
    }
}

export default TextWidget;